import React, { useState, useEffect } from "react";
import { Calendar, dateFnsLocalizer, Views } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import { startOfWeek, eachDayOfInterval, endOfWeek } from "date-fns";
import getDay from "date-fns/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./event-calendar.css";
// import { getCookie } from '../../getcookie.js';
// import axios from 'axios';
import { Container, Row, Col } from "react-bootstrap";
import {
  addMonths,
  subMonths,
  addWeeks,
  subWeeks,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import prevIcon from "../../assets/svg/arrow-prev.svg";
import nextIcon from "../../assets/svg/arrow-next.svg";
import calendarIcon from "../../assets/svg/calendar.svg";
import moment from "moment";
import CalendarDateViewModal from "./calendar-date-view.js";
import ReactCalendar from "react-calendar";
import "./react-calendar.css";
import Switch from "react-switch";
import {
  getCallListApi,
  getHRNexusListApi,
  getTicketListApi,
} from "./calendar-api.js";
import { useMsal } from "@azure/msal-react";
import microsoftIcon from "../../assets/svg/microsoft.svg";
const locales = {
  "en-US": require("date-fns/locale/en-US"),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
const formats = {
  dayFormat: (date, culture, localizer) =>
    localizer.format(date, "EEE dd MMM", culture),
  weekdayFormat: (date, culture, localizer) =>
    localizer.format(date, "EEEE", culture),
  timeGutterFormat: (date, culture, localizer) =>
    localizer.format(date, "hh:mm a"),
};

const GRAPH_ENDPOINT = "https://graph.microsoft.com/v1.0/me/calendar/events";

const CalendarView = ({ tableData = [], listingType }) => {
  const [isTickGoEnable, setIsTickGoEnable] = useState(false);
  const [isMeetQEnable, setIsMeetQEnable] = useState(false);
  const [isHRNexusEnable, setIsHRNexusEnable] = useState(false);
  const [isCallEnable, setIsCallEnable] = useState(false);
  const [isMicrosoftEnable, setIsMicrosoftEnable] = useState(false);

  const [calendarEventList, setCalendarEventList] = useState([]);
  const [calendarTicketList, setCalendarTicketList] = useState([]);
  const [calendarHRNexusList, setCalendarHRNexusList] = useState([]);
  const [calendarCallList, setCalendarCallList] = useState([]);
  const [calendarMicrosoftList, setCalendarMicrosoftList] = useState([]);

  const [view, setView] = useState(Views.MONTH);
  const [events, setEvents] = useState([
    /*  {
      type:'present',
      title: 'Present',
      leave_type: "Present",
      duration:'9:00 hrs',
      allDay: true,
      start: new Date(2025, 0, 22),
      end: new Date(2025, 0, 22),
    },
   
    {
      type:'absent',
      title: 'Absent',
      leave_type: "Compensation leave",
      duration:'Sick Leave',
      allDay: true,
      start: new Date(2025, 0, 25, 10, 0),
      end: new Date(2025, 0, 25, 12, 0),
    }, */
  ]);
  const [showDateModelView, setShowDateModelView] = useState(false);
  const CustomEvent = ({ event }) => {
    let backgroundColor = "#EBE0FF";
    let borderColor = "3px solid #6929E2";
    if (event.status === "Open") {
      backgroundColor = "#EBE0FF";
      borderColor = "3px solid #6929E2";
    } else if (event.status === "In Progress" || event.status === "Hold") {
      backgroundColor = "#FFF6E9";
      borderColor = "3px solid #FFBA57";
    } else if (event.status === "Closed" || event.status === "Completed") {
      backgroundColor = "#CDFFE2";
      borderColor = "3px solid #17B65B";
    }
    return (
      <div
        style={{
          backgroundColor: backgroundColor,
          padding: "2px",
          borderLeft: borderColor,
          marginLeft: "3px" /* borderRadius:'5px' */,
        }}
      >
        <div style={{ fontSize: "11px", fontWeight: "500", color: "#212129" }}>
          {event.title}
        </div>
      </div>
    );
  };
  const eventStyleGetter = (event) => {
    let backgroundColor = "#EBE0FF";
    if (event.status === "Open") {
      backgroundColor = "#EBE0FF";
    } else if (event.status === "In Progress" || event.status === "Hold") {
      backgroundColor = "#FFF6E9";
    } else if (event.status === "Closed" || event.status === "Completed") {
      backgroundColor = "#CDFFE2";
    }
    return {
      style: {
        backgroundColor,
        color: "white",
        borderRadius: "3px",

        paddingRight: "1px",
        border: "none",
      },
    };
  };
  const dayPropGetter = (date) => {
    /* const hasEvent = tableData.some(
      (event) =>
        date.toDateString() === new Date(event.start).toDateString() || // Check if date matches event start
        date.toDateString() === new Date(event.end).toDateString() // Check if date matches event end
    );
  
    return {
      style: {
        backgroundColor: hasEvent ? '#87ceeb' : '', // Highlight color for event dates
        borderRadius: '5px',
      },
    }; */
    const day = date.getDay(); // Get day index (0 = Sunday, 6 = Saturday)

    if (day === 0) {
      return { style: { backgroundColor: "#F7F8F9" } }; // Sunday (Red)
    } else {
      return { style: { backgroundColor: "#FFFFFF" } };
    }

    return {};
  };
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Monthly");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedOnDay, setSelectedOnDay] = useState(null);
  const [attendanceCount, setAttendanceCount] = useState({});
  const [weekDays, setWeekDays] = useState([]);

  const [weeklyEvents, setWeeklyEvents] = useState([]);
  useEffect(() => {
    setSelectedDate(new Date());
  }, []);
  useEffect(() => {
    console.log(selectedDate);
    if (selectedDate != null) {
      getTicketList();
      getHRNexusList();
      getCallList();
      fetchMicrosoftEvents();
      if (selectedTab === "Weekly") {
        // onChangeDateRange({startDate: startOfWeek(selectedDate), endDate: endOfWeek(selectedDate),});
      }
      if (selectedTab === "Monthly") {
        //onChangeDateRange({startDate: startOfMonth(selectedDate), endDate: endOfMonth(selectedDate),})
      }
    }
  }, [selectedDate]);
  useEffect(() => {
    if (isTickGoEnable === true) {
      getTicketList();
    } else {
      resetEventList();
    }
  }, [isTickGoEnable]);

  useEffect(() => {
    if (isHRNexusEnable === true) {
      getHRNexusList();
    } else {
      resetEventList();
    }
  }, [isHRNexusEnable]);

  useEffect(() => {
    if (isCallEnable === true) {
      getCallList();
    } else {
      resetEventList();
    }
  }, [isCallEnable]);
  useEffect(() => {
    if (isMicrosoftEnable === true) {
      fetchMicrosoftEvents();
    } else {
      resetEventList();
    }
  }, [isMicrosoftEnable]);

  const resetEventList = () => {
    const eventTemp = [];
    if (isTickGoEnable === true) {
      eventTemp.push(...calendarTicketList);
    }
    if (isHRNexusEnable === true) {
      eventTemp.push(...calendarHRNexusList);
    }
    if (isCallEnable === true) {
      eventTemp.push(...calendarCallList);
    }
    if (isMicrosoftEnable === true) {
      eventTemp.push(...calendarMicrosoftList);
    }
    setCalendarEventList(eventTemp);
  };
  const getTicketList = async () => {
    try {
      const response = await getTicketListApi({
        type: "",
        from_date: getFromDate(),
        to_date: getToDate(),
        search: "",
      });
      if (response.data.success === true) {
        const eventTemp = [];
        response.data.data.forEach((item) => {
          const date = moment(item["date"], "DD-MM-YYYY").toDate();
          item.tickets.forEach((ticket) => {
            eventTemp.push({
              title: ticket.title,
              color: "",
              duration: item["duration"] ?? "00:00",
              status: ticket.status,
              allDay: true,
              start: date,
              end: date,
              event_date: item["date"],
            });
          });
        });
        setCalendarTicketList(eventTemp);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getHRNexusList = async () => {
    try {
      const response = await getHRNexusListApi({
        type: "",
        from_date: getFromDate(),
        to_date: getToDate(),
        search: "",
        status: "All",
      });
      if (response.data.success === true) {
        const eventTemp = [];
        response.data.absent.forEach((item) => {
          const date = parse(item["date"], "dd-MM-yyyy", new Date());

          eventTemp.push({
            title:
              (item["leave_type"] ?? "") +
              (item["period_type"] !== ""
                ? "(" + item["period_type"] + ")"
                : ""),
            color: "",
            type: "absent",
            period: item["period"] ?? "",
            period_type: item["period_type"] ?? "",
            allDay: true,
            start: date,
            end: date,
            event_date: item["date"],
          });
        });

        response.data.present.forEach((item) => {
          const date = parse(item["date"], "dd-MM-yyyy", new Date());
          eventTemp.push({
            title: "Present(" + (item["short_name"] ?? "-") + ")",
            color: "",
            duration: item["duration"] ?? "00:00",
            type: "present",
            check_in_status: item["check_in_status"] ?? "",
            allDay: true,
            start: date,
            end: date,
            event_date: item["date"],
            break_duration: null,
            work_duration: ":",
            check_in_time: "2025-03-19 09:31:21",
            check_out_time: "2025-03-19 09:57:48",
          });
        });

        setCalendarHRNexusList(eventTemp);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCallList = async () => {
    try {
      const response = await getCallListApi({
        from_date: getFromDate(),
        to_date: getToDate(),
        search: "",
      });
      if (response.data.success === true) {
        const eventTemp = [];
        response.data.data.forEach((item) => {
          /*  const date = moment(item['date'], "DD-MM-YYYY").toDate(); */
          const start = moment(
            `${item["date"]} ${item["start_time"]}`,
            "DD-MM-YYYY HH:mm",
          ).toDate();
          const end = moment(
            `${item["date"]} ${item["end_time"]}`,
            "DD-MM-YYYY HH:mm",
          ).toDate();
          eventTemp.push({
            title: item.title,
            color: "",
            duration: "00:00",
            status: item.status,
            allDay: false,
            start: start,
            end: end,
            event_date: item["date"],
          });
          /* item.tickets.forEach((call) => {
              eventTemp.push({
                'title': call.title,
                'color': "",
                "duration": "00:00",
                'status': call.status,
                "start": start,
                "end": end,
                "event_date":item['date']
              });
            }); */
        });
        setCalendarCallList(eventTemp);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  useEffect(() => {
    resetEventList();
  }, [
    calendarTicketList,
    calendarHRNexusList,
    calendarCallList,
    calendarMicrosoftList,
  ]);

  const getFromDate = () => {
    if (selectedDate != null) {
      if (selectedTab === "Weekly") {
        return formatDateCommon(startOfWeek(selectedDate), "YYYY-MM-DD");
        // onChangeDateRange({startDate: startOfWeek(selectedDate), endDate: endOfWeek(selectedDate),});
      }
      if (selectedTab === "Monthly") {
        return formatDateCommon(startOfMonth(selectedDate), "YYYY-MM-DD");
        //onChangeDateRange({startDate: startOfMonth(selectedDate), endDate: endOfMonth(selectedDate),})
      }
    }
  };

  const getToDate = () => {
    if (selectedDate != null) {
      if (selectedTab === "Weekly") {
        return formatDateCommon(endOfWeek(selectedDate), "YYYY-MM-DD");
      }
      if (selectedTab === "Monthly") {
        return formatDateCommon(endOfMonth(selectedDate), "YYYY-MM-DD");
      }
    }
  };

  function formatDateCommon(inputDate, formatType) {
    console.log("current date time.....", inputDate);
    try {
      if (inputDate !== undefined) {
        return moment(inputDate).format(formatType);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  function getWeekDays() {
    /*  const selectedWeekDays = eachDayOfInterval({
                start: startOfWeek(selectedDate), // Start of the week
                end: endOfWeek(selectedDate)      // End of the week
              });
              console.log("Days of the Current Week:");
weekDays.forEach(day => console.log(day));
              setWeekDays(selectedWeekDays); */
  }
  function onMonthSelected() {}

  const CustomToolbar = ({ label, onNavigate }) => {
    return (
      <div
        style={{ width: "100%" }}
        className="d-flex align-items-center justify-content-between mb-2"
      >
        <div className="d-flex align-items-center">
          {/* <button style={{width:'74px', height:'36px', borderRadius:'8px', border:'0.8px solid #E5E5E5', background:'#ffffff'}}  onClick={() => onNavigate("TODAY")}>
                  <div style={{fontSize:'12px', fontWeight:'500', color:'#212129'}}></div> Today
                   </button> */}

          {/*  <button className='mx-2' style={{width:'74px', height:'36px', borderRadius:'8px',color:selectedTab==='Weekly'?'#6929E2':'#212129', background:selectedTab==='Weekly'?'#F0E9FF' :'#ffffff', border:selectedTab==='Weekly'? '0.8px solid #F0E9FF':'0.8px solid #E5E5E5'}}  onClick={() =>{setSelectedTab('Weekly');setView(Views.WEEK)} }>
                  <div style={{fontSize:'12px', fontWeight:'500', }}></div> Weekly
                   </button>

                   <button style={{width:'74px', height:'36px', borderRadius:'8px',background:selectedTab==='Monthly'?'#F0E9FF' :'#ffffff', color: selectedTab==='Monthly'?'#6929E2':'#212129', border:selectedTab==='Monthly'? '0.8px solid #F0E9FF':'0.8px solid #E5E5E5'}}  onClick={() => {setSelectedTab('Monthly');setView(Views.MONTH);}}>
                  <div style={{fontSize:'12px', fontWeight:'500',}}></div> Monthly
                   </button> */}
        </div>

        <div className="d-flex align-items-center justify-content-end">
          <select
            className="select3 me-2"
            id="perpage"
            value={selectedTab}
            onChange={(event) => {
              setSelectedTab(event.target.value);
              if (event.target.value === "Weekly") {
                setView(Views.WEEK);
              } else if (event.target.value === "Monthly") {
                setView(Views.MONTH);
              }
            }}
            style={{
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "400",
              color: "#212129",
              width: "110px",
              height: "36px",
              borderRadius: "4px",
              border: "1px solid #DADCE0",
              padding: "0 4px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
          </select>
          <img src={calendarIcon} className="ar3" alt="calendar" />
          <span
            className="mx-2"
            style={{ fontSize: "14px", fontWeight: "500", color: "#212129" }}
          >
            {label}
          </span>
          <button
            style={{
              width: "36px",
              height: "36px",
              border: "0.8px solid #E5E5E5",
              borderRadius: "100px",
              background: "#ffffff",
            }}
            onClick={() => {
              onNavigate("PREV");
              if (selectedTab === "Monthly") {
                setSelectedDate(subMonths(selectedDate, 1));
              }
              if (selectedTab === "Weekly") {
                setSelectedDate(subWeeks(selectedDate, 1));
              }
            }}
          >
            <img src={prevIcon} className="ar3" alt="previous" />
          </button>
          <button
            style={{
              marginLeft: "8px",
              width: "36px",
              height: "36px",
              border: "0.8px solid #E5E5E5",
              borderRadius: "100px",
              background: "#ffffff",
            }}
            onClick={() => {
              onNavigate("NEXT");
              if (selectedTab === "Monthly") {
                setSelectedDate(addMonths(selectedDate, 1));
              }
              if (selectedTab === "Weekly") {
                setSelectedDate(addWeeks(selectedDate, 1));
              }
            }}
          >
            <img src={nextIcon} className="ar3" alt="next" />
          </button>
        </div>
      </div>
    );
  };
  const messages = {
    showMore: (count) => (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: "60px",
          paddingTop: "1px",
          paddingBottom: "1px",
          background: "#6929E2",
          color: "#FFFFFF",
          borderRadius: "8px",
          fontSize: "10px",
          fontWeight: "600",
          textAlign: "center",
        }}
      >
        +{count} more
      </div>
    ), // Customize the text
  };

  const handleSelectSlot = (slotInfo) => {
    setSelectedOnDay(slotInfo.start);
    setShowDateModelView(true);
    console.log(slotInfo.start);
  };
  const handleNavigate = (newDate, view, action) => {
    if (view === Views.DAY) {
      console.log("Navigation to Day view is blocked.");
      return; // Prevents changing to the Day view
    }
    setView(view);
  };
  const CustomDateHeader = ({ label }) => (
    <div
      style={{
        textAlign: "left",
        paddingLeft: "4px",
        fontSize: "14px",
        fontWeight: "500",
        color: "#828C94",
      }}
    >
      {label}
    </div>
  );
  const handleActiveStartDateChange = ({ activeStartDate }) => {
    // const start = new Date(activeStartDate);
    // const end = new Date(start.getFullYear(), start.getMonth() + 1, 0); // Last day of month
    setSelectedDate(new Date(activeStartDate));

    // setRange({ start, end });
    //console.log('Start:', start.toDateString(), 'End:', end.toDateString());
  };

  const { instance, accounts } = useMsal();
  useEffect(() => {
    const fetchEvents = async () => {
      const request = {
        scopes: ["Calendars.Read"],
        account: accounts[0],
      };

      try {
        const response = await instance.acquireTokenSilent(request);
        const events = await fetch(GRAPH_ENDPOINT, {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        }).then((res) => res.json());

        console.log("Events", events);
        if (events?.value.length > 0) {
          const eventTemp = [];
          events?.value.forEach((item) => {
            /*  const date = moment(item['date'], "DD-MM-YYYY").toDate(); */
            const start = moment(
              `${item["date"]} ${item["start_time"]}`,
              "DD-MM-YYYY HH:mm",
            ).toDate();
            const end = moment(
              `${item["date"]} ${item["end_time"]}`,
              "DD-MM-YYYY HH:mm",
            ).toDate();
            eventTemp.push({
              title: item.subject,
              color: "",
              duration: "00:00",
              status: "",
              allDay: false,
              start: new Date(item.start?.dateTime),
              end: new Date(item.end?.dateTime),
              event_date: item.start?.dateTime,
            });
            /* item.tickets.forEach((call) => {
              eventTemp.push({
                'title': call.title,
                'color': "",
                "duration": "00:00",
                'status': call.status,
                "start": start,
                "end": end,
                "event_date":item['date']
              });
            }); */
          });
          setCalendarMicrosoftList(eventTemp);
        }
      } catch (error) {
        console.error("Error fetching events", error);
      }
    };

    if (accounts.length > 0) {
      setIsMicrosoftEnable(true);
      fetchEvents();
    }
  }, [accounts, instance]);
  const account = accounts.length > 0 ? accounts[0] : null;

  const fetchMicrosoftEvents = async () => {
    const request = {
      scopes: ["Calendars.Read"],
      account: accounts[0],
    };

    try {
      const response = await instance.acquireTokenSilent(request);
      const events = await fetch(
        `https://graph.microsoft.com/v1.0/me/calendarview?startDateTime=${getFromDate()}T00:00:00Z&endDateTime=${getToDate()}T23:59:59Z&$orderby=start/dateTime`,
        {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        },
      ).then((res) => res.json());

      console.log("Events", events);
      if (events?.value.length > 0) {
        const eventTemp = [];
        events?.value.forEach((item) => {
          /*  const date = moment(item['date'], "DD-MM-YYYY").toDate(); */
          const start = moment(
            `${item["date"]} ${item["start_time"]}`,
            "DD-MM-YYYY HH:mm",
          ).toDate();
          const end = moment(
            `${item["date"]} ${item["end_time"]}`,
            "DD-MM-YYYY HH:mm",
          ).toDate();
          eventTemp.push({
            title: item.subject,
            color: "",
            duration: "00:00",
            status: "",
            allDay: false,
            start: new Date(item.start?.dateTime),
            end: new Date(item.end?.dateTime),
            event_date: item.start?.dateTime,
          });
          /* item.tickets.forEach((call) => {
              eventTemp.push({
                'title': call.title,
                'color': "",
                "duration": "00:00",
                'status': call.status,
                "start": start,
                "end": end,
                "event_date":item['date']
              });
            }); */
        });
        setCalendarMicrosoftList(eventTemp);
      }
    } catch (error) {
      console.error("Error fetching events", error);
    }
  };
  return (
    <div style={{ display: "flex", padding: "16px" }}>
      {showDateModelView && (
        <CalendarDateViewModal
          selectedDate={moment(new Date(selectedOnDay)).format("YYYY-MM-DD")}
          listingType={listingType}
          onHide={() => {
            setShowDateModelView(false);
          }}
        />
      )}
      <Row
        sm={12}
        style={{
          width: "calc(100vw - 17vw)",
          overflow: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          justifyContent: "center",
        }}
      >
        <Col sm={2} style={{ background: "#EFFAFF" }}>
          <div className="my-3">
            <ReactCalendar
              onChange={setSelectedDate}
              onActiveStartDateChange={handleActiveStartDateChange}
              value={selectedDate}
              next2Label={null}
              prev2Label={null}
              locale="en-US"
              formatShortWeekday={(locale, date) =>
                date.toLocaleDateString(locale, { weekday: "narrow" })
              }
            />
          </div>
          <div className="border-line"></div>

          <div className="mt-2 style-justify-between">
            <div className="font_13_400_2E3032">Call </div>
            <div>
              <Switch
                onChange={setIsCallEnable}
                checked={isCallEnable}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor="#4872F4"
                offColor="#ccc"
                height={18}
                width={36}
                handleDiameter={14}
              />
            </div>
          </div>

          <div className="mt-2 style-justify-between">
            <div className="font_13_400_2E3032">Tickgo </div>
            <div>
              <Switch
                onChange={setIsTickGoEnable}
                checked={isTickGoEnable}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor="#4872F4"
                offColor="#ccc"
                height={18}
                width={36}
                handleDiameter={14}
              />
            </div>
          </div>

          <div className="mt-2 style-justify-between">
            <div className="font_13_400_2E3032">HR Nexus </div>
            <div>
              <Switch
                onChange={setIsHRNexusEnable}
                checked={isHRNexusEnable}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor="#4872F4"
                offColor="#ccc"
                height={18}
                width={36}
                handleDiameter={14}
              />
            </div>
          </div>

          <div>
            {account ? (
              <div className="mt-2 style-justify-between">
                <div className="font_13_400_2E3032">{account.username} </div>
                <div>
                  <Switch
                    onChange={setIsMicrosoftEnable}
                    checked={isMicrosoftEnable}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onColor="#4872F4"
                    offColor="#ccc"
                    height={18}
                    width={36}
                    handleDiameter={14}
                  />
                </div>
              </div>
            ) : (
              <button
                onClick={() =>
                  instance.loginRedirect({
                    scopes: ["User.Read", "Calendars.Read"],
                  })
                }
                style={{ border: "none", background: "transparent" }}
              >
                <img src={microsoftIcon} className="ar3" alt="calendar" />{" "}
                <span className="font_13_400_2E3032">Microsoft Account</span>
              </button>
            )}
          </div>
        </Col>
        <Col sm={10} style={{ padding: "12px", justifyContent: "center" }}>
          <div
            style={{
              borderRadius: "16px",
              padding: "8px",
              background: "#FFFFFF",
            }}
          >
            <Calendar
              className="GTWalsheimTrial"
              localizer={localizer}
              selectable
              /* onSelectSlot={handleSelectSlot} */
              events={calendarEventList}
              startAccessor="start"
              endAccessor="end"
              date={selectedDate}
              style={{
                flexGrow: 1,
                minHeight: "500px",
                /* height: 'calc(100vh - 190px)', */ margin: "8px",
              }}
              view={view} // Controlled view state
              onNavigate={handleNavigate}
              onView={(newView) => setView(newView)} // Update view state
              components={{
                /* toolbar: () => null, */
                toolbar: CustomToolbar,
                event: CustomEvent,
                month: {
                  dateHeader: CustomDateHeader, // Left-aligned day number
                },
                /*  month: {
            messages,
          }, */
                /*  timeGutterHeader: () => null, // Hide time header
        timeGutter: () => null, // Hide time */
              }}
              eventPropGetter={eventStyleGetter}
              dayPropGetter={dayPropGetter}
              messages={messages}
              step={30} // Controls the time slot steps, but not needed when time grid is hidden
              // min={null} // Disable minimum time
              // max={null} // Disable maximum time
              popup={true} // Disables "Show More" popup
              onShowMore={(events, date) => {
                console.log("Show More clicked", events, date);
                /*  setSelectedOnDay(date);
          setShowDateModelView(true); */
                return null; // Prevents default "Show More" action
              }}
              /* onSelectEvent={(event, e) => {
          e.preventDefault(); // Prevents event click action
          console.log("Event Click Disabled", event);
          setSelectedOnDay(moment(event.event_date, "DD-MM-YYYY").toDate());
          setShowDateModelView(true);
        }} */
              formats={formats}
              timeslots={2}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CalendarView;
